import { parse as h, serialize as n } from "../../../../cookie@0.5.0/node_modules/cookie/index.js";
import { parseCookies as c, hasDocumentCookie as a, readCookie as o } from "./utils.js";
class d {
  constructor(e, t = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const s = this.cookies;
      this.cookies = h(document.cookie), this._checkChanges(s);
    };
    const i = typeof document > "u" ? "" : document.cookie;
    this.cookies = c(e || i), this.defaultSetOptions = t, this.HAS_DOCUMENT_COOKIE = a();
  }
  _emitChange(e) {
    for (let t = 0; t < this.changeListeners.length; ++t)
      this.changeListeners[t](e);
  }
  _checkChanges(e) {
    new Set(Object.keys(e).concat(Object.keys(this.cookies))).forEach((i) => {
      e[i] !== this.cookies[i] && this._emitChange({
        name: i,
        value: o(e[i])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(e, t = {}) {
    return t.doNotUpdate || this.update(), o(this.cookies[e], t);
  }
  getAll(e = {}) {
    e.doNotUpdate || this.update();
    const t = {};
    for (let i in this.cookies)
      t[i] = o(this.cookies[i], e);
    return t;
  }
  set(e, t, i) {
    i ? i = Object.assign(Object.assign({}, this.defaultSetOptions), i) : i = this.defaultSetOptions;
    const s = typeof t == "string" ? t : JSON.stringify(t);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [e]: s }), this.HAS_DOCUMENT_COOKIE && (document.cookie = n(e, s, i)), this._emitChange({ name: e, value: t, options: i });
  }
  remove(e, t) {
    const i = t = Object.assign(Object.assign({}, t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = n(e, "", i)), this._emitChange({ name: e, value: void 0, options: t });
  }
  addChangeListener(e) {
    this.changeListeners.push(e), this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(e) {
    const t = this.changeListeners.indexOf(e);
    t >= 0 && this.changeListeners.splice(t, 1), this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
export {
  d as default
};
